document.addEventListener("click", function (e) {

  const target = e.target.closest("[data-membership-event]");

  if (!target) return;

  window.dataLayer = window.dataLayer || [];

  if (target.dataset.membershipEvent === "join") {

    window.dataLayer.push({

      event: "membership_join_click",

      device: target.dataset.device

    });

  }

  if (target.dataset.membershipEvent === "card") {

    window.dataLayer.push({

      event: "membership_card_click",

      device: target.dataset.device,

      card_index: target.dataset.cardIndex,

      card_title: target.dataset.cardTitle,

      card_badge: target.dataset.cardBadge

    });

  }

});